<template>
  <section id="download" class="flex-row">
    <hgroup full>


      <img src="@/assets/download-step1.png" style="position: absolute;width:12.5rem;height:3.358rem;top:0;left:0;">

      <section class="flex-col" style="position: absolute;left:5.41rem;top:0.64rem;">

        <h4 class="font-36">Download & Ajukan Sekarang!</h4>
        <h4 style="margin-top:0.2rem">Hadir untuk solusi finansial Anda, unduh aplikasi AdaPundi Sekarang</h4>
        <img @click="btnDownload" src="@/assets/download-step2.png" style="cursor:pointer;margin-top:0.2rem;width:2.39rem;height:0.71rem;">

      </section>


    </hgroup>
  </section>
</template>
<script>


export default {
  mixins: [],
  name: "download",
  data() {
    return {
    };
  },
  methods: {
    btnDownload(){
      location.href=this.$urlDownloadApp;
    }

  },
};

</script>
<style scoped lang="scss">
  #download{
    padding:0.36rem 0.58rem ;
    width:100%;min-height:3.72rem;
    background:linear-gradient(rgba(16,193,160,1) 0%, rgba(23,136,131,1) 100%);
  }
</style>
